import './cookie-preferences.scss';

/**
 * version    1.0
 * class      <type> (CookiePreferences)
 * classdesc  Modale di gestione delle preferenze dei cookie
 */
export class CookiePreferences {
  constructor() {
    this.init();
  }

  // private methods

  init() {
    const self = this;

    /**
     * Salva preferenze cookie selettive
     */
    $('#s-pref').on('click', () => {
      const analyticsEnabled = $('#analitycs-cookie').is(':checked');
      self.setCookie('cookies_consent', analyticsEnabled, 365);

      if (!analyticsEnabled) {
        window.location.reload();
      }
    });

    /**
     * Accetta tutti i cookie
     */
    $('#s-all').on('click', () => {
      self.setCookie('cookies_consent', true, 365);
    });

    /**
     * Chiusura modale cookie senza consenso
     */
    $('#close-modal-cookie').on('click', () => {
      if (!document.cookie.includes('cookies_consent')) {
        $('.cookiebar').show();
      }
    });

    /**
     * Apertura preferenze cookie
     */
    $('#pref-modal').on('click', () => {
      $('.cookiebar').hide();
    });
  }

  /**
   * Imposta un cookie con durata in giorni
   */
  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}
